class Base {
  setup () {
    throw 'Not implemented'
  }
}

export default Base
